




















































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'
import { Button, Icon } from '@/components/general'

// Models
import { Paginator } from '@/models'
import { CuartaCategoria } from '@/models/dailyControl'

export default defineComponent({
  name: 'CuartaCategoriaTableList',
  components: {
    DataTable,
    IsActive,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<CuartaCategoria[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const getTypeTextc = (type) => {
      switch (type) {
        case 1:
          return 'RECIBO POR HONORARIOS'
        case 2:
          return 'SUMA GRACIOSA'
        case 3:
          return 'OTROS BONOS'
        default:
          return 'Desconocido'
      }
    }

    const fields = [
      {
        key: 'register_date',
        sortable: true,
        label: 'Fecha de Registro'
      },
      {
        key: 'discount_date',
        sortable: true,
        label: 'Fecha de Aplicación'
      },
      {
        key: 'employee.name',
        sortable: true,
        label: 'Empleado'
      },
      {
        key: 'type',
        sortable: true,
        label: 'Tipo'
      },
      {
        key: 'amount',
        sortable: true,
        label: 'Importe'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '10%'
        }
      }
    ]
    return {
      fields,
      getTypeTextc
    }
  }
})
